import React, { useState } from 'react';
import { getNoSkillMessage, getTenant, useProfileSkills } from '../../../hooks';
import { SkillSearchBar } from '../../../components';
import { SkillSection } from '../../../components/SkillSection';
import { AddSkillButton } from '../AddSkillButton';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { SKILL_TYPES } from '../../../components/SliderInstance/helpers/skillLevel';

interface SkillsViewContentProps {
  username: string;
}

export const SkillsViewContent: React.FC<SkillsViewContentProps> = ({
  username,
}) => {
  const { t } = useTranslation('library');
  const [searchTerm, setSearchTerm] = useState('');
  const [
    userEarnedSkillsData,
    userEarnedSkillsDataLoaded,
    highlightedSkillsData,
    highlightedSkillsDataLoaded,
    userSelfReportedSkillsData,
    userSelfReportedSkillsDataLoaded,
    setUserSelfReportedSkillsData,
    setHighlightedSkillsData,
    userEarnedSkillsNewFormatData
  ] = useProfileSkills(username, getTenant());

  const skillsEmpty = (userEarnedSkillsNewFormatData?.length === 0 && userSelfReportedSkillsData?.length === 0 && highlightedSkillsData?.length === 0) ? true : false;

  return (
    <div
      className="ov_panel active"
      data-name="skills"
      style={{ marginTop: '20px' }}
    >
      <SkillSearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} skillsEmpty={skillsEmpty} />
      <SkillSection
        title={t('Earned Skills')}
        skillsData={userEarnedSkillsNewFormatData}
        skillsDataLoaded={userEarnedSkillsDataLoaded}
        refreshSkills={() => { }}
        searchTerm={searchTerm}
        noSkillsMessage={getNoSkillMessage('earned', username)}
        sectionType={SKILL_TYPES.EARNED}
      />
      <div>
        {userSelfReportedSkillsDataLoaded && !inIframe() && (
          <AddSkillButton
            skillType="selfReported"
            skillsData={userSelfReportedSkillsData}
            refreshSkills={setUserSelfReportedSkillsData}
          />
        )}

        <SkillSection
          title={t('Self-Reported')}
          skillsData={userSelfReportedSkillsData}
          skillsDataLoaded={userSelfReportedSkillsDataLoaded}
          refreshSkills={setUserSelfReportedSkillsData}
          searchTerm={searchTerm}
          noSkillsMessage={getNoSkillMessage('self-reported', username)}
          sectionType={SKILL_TYPES.SELF_REPORTED}
        />
      </div>

      <div>
        {highlightedSkillsDataLoaded && !inIframe() && (
          <AddSkillButton
            skillType="highlighted"
            skillsData={highlightedSkillsData}
            refreshSkills={setHighlightedSkillsData}
          />
        )}
        <SkillSection
          title={t('Desired')}
          skillsData={highlightedSkillsData}
          skillsDataLoaded={highlightedSkillsDataLoaded}
          refreshSkills={setHighlightedSkillsData}
          searchTerm={searchTerm}
          noSkillsMessage={getNoSkillMessage('desired', username)}
          sectionType={SKILL_TYPES.DESIRED}
        />
      </div>
    </div>
  );
};
